var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common-getCode"},[(_vm.flag)?_c('span',{staticClass:"getCode-button text-primary",on:{"click":_vm.start}},[_vm._v(_vm._s(_vm.$t("common.getCode")))]):_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.num)+"s")])])
}
var staticRenderFns = []

export { render, staticRenderFns }